'use client';

import { c as _c } from "react/compiler-runtime";
import type { IconifyIcon, IconProps } from '@iconify/react';
import { Icon } from '@iconify/react';
import type { IconifyName } from './register-icons';
import { allIconNames, registerIcons } from './register-icons';

// ----------------------------------------------------------------------

export interface IconifyProps extends Omit<IconProps, 'icon' | 'color'> {
  icon: IconifyName | IconifyIcon | string;
  width?: number;
  height?: number;
  className?: string;
}
export function Iconify(t0) {
  const $ = _c(13);
  let className;
  let height;
  let icon;
  let other;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      icon,
      width: t1,
      height,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = height;
    $[3] = icon;
    $[4] = other;
    $[5] = t1;
  } else {
    className = $[1];
    height = $[2];
    icon = $[3];
    other = $[4];
    t1 = $[5];
  }
  const width = t1 === undefined ? 20 : t1;
  if (!allIconNames.includes(icon as IconifyName)) {
    console.warn([`Иконка "${icon}" в настоящее время загружается онлайн, что может вызвать эффект мигания.`, "\u0427\u0442\u043E\u0431\u044B \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0442\u044C \u0431\u043E\u043B\u0435\u0435 \u043F\u043B\u0430\u0432\u043D\u0443\u044E \u0440\u0430\u0431\u043E\u0442\u0443, \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435 \u0432\u0430\u0448\u0443 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E \u0438\u043A\u043E\u043D\u043E\u043A \u0434\u043B\u044F \u043E\u0444\u0444\u043B\u0430\u0439\u043D \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F."].join("\n"));
  }
  registerIcons();
  const t2 = height ?? width;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      flexShrink: 0,
      display: "inline-flex"
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== icon || $[9] !== other || $[10] !== t2 || $[11] !== width) {
    t4 = <Icon icon={icon} width={width} height={t2} className={className} style={t3} {...other} />;
    $[7] = className;
    $[8] = icon;
    $[9] = other;
    $[10] = t2;
    $[11] = width;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}